// Store of all hardcoded codes

const { burn } = require('./subcodes/burn');
const { stroke } = require('./subcodes/stroke');

exports.subcodes = {
  burn,
  stroke
};